import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./PickADay.module.css";
import clsx from "clsx";
import { usePickADayContext } from "./PickADayContext";

const Year: React.FC<{ year: number; isCurrent: boolean }> = ({
  year,
  isCurrent,
}) => {
  const { setYear } = usePickADayContext();

  const handleClick = useCallback(() => {
    setYear(year);
  }, [year, setYear]);

  return (
    <div
      className={clsx(styles.PickADay__year, { [styles._on]: isCurrent })}
      onClick={handleClick}
    >
      {year}
    </div>
  );
};

export const PickADayYearSelector = () => {
  const { year } = usePickADayContext();

  const scrollRef = useRef<HTMLDivElement>(null);

  const [yearsList, setYearsList] = useState([year]);

  useEffect(() => {
    const list = [];
    let oldYear = year - 100;

    while (list.length < 200) {
      oldYear++;
      list.push(oldYear);
    }

    setYearsList(list);
  }, [year]);

  const scrollToYear = useCallback(() => {
    const count = yearsList.length;
    const index = yearsList.indexOf(year);
    const height = scrollRef.current?.scrollHeight || 0;
    const offsetHeight = scrollRef.current?.offsetHeight || 0;
    const oneYearHeight = height / count;
    if (scrollRef.current) {
      scrollRef.current.scrollTop = index * oneYearHeight - offsetHeight / 2;
    }
  }, [yearsList, year]);

  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleTouchEnd = useCallback(() => {
    if (timeout.current !== null) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(scrollToYear, 5000);
  }, [scrollToYear]);

  useEffect(() => {
    scrollToYear();
  }, [yearsList, scrollToYear]);

  return (
    <div className={styles.PickADay__years_list}>
      <div
        className={styles.PickADay__years}
        ref={scrollRef}
        onMouseLeave={scrollToYear}
        onTouchEnd={handleTouchEnd}
      >
        {yearsList.map((item) => (
          <Year key={item} year={item} isCurrent={item === year} />
        ))}
      </div>
    </div>
  );
};
